import React, { useState } from "react";
import PropTypes from "prop-types";

const EmailInputField = ({
  title,
  placeholder,
  width = "400px",
  value,
  onChange,
  validationMessage = "This field is required.",
}) => {
  const [error, setError] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleBlur = () => {
    if (!value.trim()) {
      setError(validationMessage);
    } else if (!validateEmail(value)) {
      setError("Please provide a valid email address.");
    } else {
      setError("");
    }
  };

  const handleFocus = () => {
    if (error) setError("");
  };

  return (
    <div className="dd-input-group" style={{ maxWidth: width }}>
      <label className="dd-section-label">
        {title} <span className="dd-required">*</span>
      </label>
      <div className="dd-input-wrapper">
        <input
          className={`dd-input ${error ? "dd-input-error" : ""}`}
          type="email"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
        {error && (
          <span className="dd-error-icon" title={error}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#EF4444"
              strokeWidth="1.5"
            >
              <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10Z" />
              <path
                d="M12 8v5M11.995 16h.009"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
      </div>
      {error && (
        <div className="dd-error-msg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#EF4444"
            strokeWidth="1.5"
          >
            <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10Z" />
            <path
              d="M12 8v5M11.995 16h.009"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {error}
        </div>
      )}
    </div>
  );
};

EmailInputField.propTypes = {
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  width: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validationMessage: PropTypes.string,
};

export default EmailInputField;
